import React, { useMemo } from "react";
import styled from "styled-components";
import { Csku, useWindowSize } from "@commonsku/styles";
import { getReportConfig, ReportConfig } from "../../report/config";
import { ReportProvider } from "../../report/report_context";
import ReportFiltersContainer from "../../report/filters/ReportFiltersContainer";
import ReportSummaryContainer from "../../report/summary/ReportSummaryContainer";
import ReportTable from "../../report/table/ReportTable";
import Pagination from "../../report/table/Pagination";
import Loading from "../../report/Loading";
import ActionBar from "../../report/table/ActionBar";

const FeeReportContainer = styled.div`
  position: relative;
`;

interface FeeReportProps {
  shop_id: string;
  is_aggregate: number;
}

export const FeeReport = ({ shop_id, is_aggregate }: FeeReportProps) => {
  const report_type = `shop-fee`.toUpperCase();
  const reportConfig: ReportConfig = useMemo(
    () => getReportConfig(report_type),
    [report_type],
  );

  const defaultFilters = useMemo(
    () => ({
      shop_id: shop_id,
      is_aggregate: `${is_aggregate}`,
    }),
    []
  );

  const windowHeight = useWindowSize()[1];

  if (!reportConfig) {
    return null;
  }

  return (
    <ReportProvider
      reportConfig={reportConfig}
      defaultFilters={defaultFilters}
      containerHeight={windowHeight}
    >
      <Csku as={"div"} className="csku-styles" style={{ marginTop: 16}}>
        <FeeReportContainer>
          <ReportFiltersContainer />
          <ReportSummaryContainer />
          <ReportTable />
          <Pagination />
          <Loading />
        </FeeReportContainer>

        <ActionBar />
      </Csku>
    </ReportProvider>
  );
};